<template>
  <div
    :class="[
     'bb-notifications-bar-main-icon',
     item.notificationStatus && `bb-notifications-bar-main-icon_${item.notificationStatus.class}`,
     isReminder && 'bb-notifications-bar-main-icon_reminder',
     isBgRed && 'bb-notifications-bar-main-icon_background-red',
     isAcademy && 'bb-notifications-bar-main-icon_background-blue'
    ]"
    v-html="getIcon"
  />
</template>

<script>
import { USER_NOTIFICATION } from '@/constants/userNotification'
import {
  MessageNotificationIcon,
  BellIcon,
  AccessTimeNotificationIcon,
  EmailIcon,
  AcademyCourseIcon
} from '@/constants/icon'

export default {
  name: 'NotificationsBarMainIcon',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    CLIENT_NOTIFICATION_SYSTEM: USER_NOTIFICATION.CLIENT_NOTIFICATION_SYSTEM,
    USER_NOTIFICATION_REMINDER: USER_NOTIFICATION.USER_NOTIFICATION_REMINDER,
    MAILING_NOTIFICATION: USER_NOTIFICATION.MAILING_NOTIFICATION,
    LIST_OF_PROJECT_NOTIFICATION: USER_NOTIFICATION.LIST_OF_PROJECT_NOTIFICATION,
    LIST_OF_ACADEMY_NOTIFICATION: USER_NOTIFICATION.LIST_OF_ACADEMY_NOTIFICATION
  }),
  computed: {
    isReminder () {
      const { eventNotification } = this.item
      return this.USER_NOTIFICATION_REMINDER === eventNotification ||
        this.MAILING_NOTIFICATION === eventNotification ||
        this.LIST_OF_PROJECT_NOTIFICATION === eventNotification
    },
    isBgRed () {
      const { eventNotification } = this.item
      return this.CLIENT_NOTIFICATION_SYSTEM === eventNotification
    },
    isAcademy () {
      const { eventNotification } = this.item
      return this.LIST_OF_ACADEMY_NOTIFICATION === eventNotification
    },
    getIcon () {
      const { eventNotification, notificationStatus } = this.item
      const {
        USER_NOTIFICATION_COMMENT,
        USER_NOTIFICATION_HR,
        USER_NOTIFICATION_REMINDER,
        CLIENT_NOTIFICATION_SYSTEM,
        MAILING_NOTIFICATION,
        LIST_OF_PROJECT_NOTIFICATION,
        LIST_OF_ACADEMY_NOTIFICATION,
      } = USER_NOTIFICATION

      switch (eventNotification) {
      case USER_NOTIFICATION_COMMENT:
        return MessageNotificationIcon()
      case USER_NOTIFICATION_HR:
        return notificationStatus.icon()
      case USER_NOTIFICATION_REMINDER:
        return BellIcon()
      case LIST_OF_PROJECT_NOTIFICATION:
        return BellIcon()
      case LIST_OF_ACADEMY_NOTIFICATION:
        return AcademyCourseIcon()
      case CLIENT_NOTIFICATION_SYSTEM:
        return AccessTimeNotificationIcon()
      case MAILING_NOTIFICATION:
        return EmailIcon()
      default:
        return ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../sass/variables";

  .bb-notifications-bar-main-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 27px;
    height: 27px;
    border-radius: 3px;

    &_background-blue {
      background: rgba($color-denim, 0.14);
    }

    &_background-green {
      background: $color-peppermint;
    }

    &_background-red {
      background: $color-red-cinderella;
    }

    &_reminder {
      background: rgba($color-denim, 0.14);
    }
    &_background-blue {
      color: $color-denim;
      background: rgba($color-denim, 0.14);
    }
  }
</style>

<style lang="scss">
@import "../../../sass/variables";

.bb-notifications-bar-main-icon svg {
  width: 15px;
}

.bb-notifications-bar-main-icon_reminder svg {
  width: 20px;

  path {
    color: $color-denim;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsBar/NotificationsBarMainIcon.vue